module.exports = __webpack_public_path__ + "static/img/code.d4712c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/code.jpg
// module id = GwFP
// module chunks = 16